import axios from 'axios';
import Vue from 'vue';
import Settings from './Settings';
import EventBus from '@/EventBus';
import Utils from '@/Utils';

export default class Backend {
  constructor(vue) {

    this.vue = vue;

    Backend.instance = this;

    if (process.env.NODE_ENV == 'development') {
      Backend.url = 'http://localhost:13001';
      Backend.apiURL = 'http://localhost:13000';
    } else {
      if (Utils.isDevEnvironment()) {
        Backend.url = 'https://dev.api.admin.smart.electronauts.net';
        Backend.apiURL = 'https://dev.api.smart.electronauts.net';
      } else {
        Backend.url = 'https://api.admin.smart.electronauts.net';
        Backend.apiURL = 'https://api.smart.electronauts.net';
      }

    }

    this.loggedIn = false;
    this.token = localStorage.getItem('token');
  }


  handleError(reject) {
    reject();
    EventBus.$emit('authError');
  }

  // *********************************************************************************************
  // * Auth                                            																				   *
  // *********************************************************************************************

  login(email, password) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/auth/login`, {email: email, password: password})
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          this.handleLogin(data);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  checkToken(token) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/auth/checktoken`, {token: token})
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          this.handleLogin(data);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  handleLogin(data) {
    this.token = data.payload.token;
    this.loggedIn = true;
    localStorage.setItem('token', this.token);
  }

  // *********************************************************************************************
  // * Cities                                         																				   *
  // *********************************************************************************************

  getCities() {
    return new Promise((resolve, reject) => {
      axios.get(`${Backend.url}/api/city/all?__test__=1&token=${this.token}`)
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  getRanking(server) {
    return new Promise((resolve, reject) => {

      let url;
      if (server == 'live') {
        url = 'https://api.smart.electronauts.net/cities';
      } else {
        url = `${ Backend.apiURL}/cities?__test__=1`;
      }

      axios.get(url)
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  activateCity(id, status) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/city/activate`, {id: id, status: status, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  changeCityDate(id, dateUTCMillis, type) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/city/changedate`, {id: id, date: dateUTCMillis, type: type, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  changeCityAddresses(id, address1, address2, address3) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/city/addresses`, {id: id, a1: address1, a2: address2, a3: address3, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  changeCityPosition(id, top, left) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/city/position`, {id: id, top: top, left: left, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  // *********************************************************************************************
  // * Maps                                            																				   *
  // *********************************************************************************************
  getMaps() {
    return new Promise((resolve, reject) => {
      axios.get(`${Backend.url}/api/maps?token=${this.token}`)
        .then((response) => {
          const data = response.data;
          console.log(response.data.payload);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  getMapData(mapKey) {
    return new Promise((resolve, reject) => {
      axios.get(`${Backend.url}/api/map/${mapKey}?token=${this.token}`)
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }


  saveMapData(mapKey, data) {
    return new Promise((resolve, reject) => {
      console.log('save', data);
      axios.post(`${Backend.url}/api/map/${mapKey}/update`, {update: data, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  // *********************************************************************************************
  // * Instagram                                       																				   *
  // *********************************************************************************************
  getTags() {
    return new Promise((resolve, reject) => {
      axios.get(`${Backend.url}/api/instagram/tags?token=${this.token}`)
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }


  getPosts(tag, page) {
    return new Promise((resolve, reject) => {
      axios.get(`${Backend.url}/api/instagram/posts/${tag}?token=${this.token}&page=${page}`)
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  blockPost(id, status) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/instagram/block`, {id: id, status: status, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  // *********************************************************************************************
  // * Quiz                                       														    						   *
  // *********************************************************************************************
  getQuestions() {
    return new Promise((resolve, reject) => {
      axios.get(`${Backend.url}/api/quiz/questions?token=${this.token}`)
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  addQuestion(question, answers, choice) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/quiz/add`, {question: question, answers: answers, choice: choice, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {

          this.handleError(reject);
        });
    });
  }

  saveQuestion(id, question, answers) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/quiz/update`, {id: id, question: question, answers: answers, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  removeQuestion(id) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/quiz/remove`, {id: id, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  // *********************************************************************************************
  // * Cms                                       														    						   *
  // *********************************************************************************************
  getPages() {
    return new Promise((resolve, reject) => {
      axios.get(`${Backend.url}/api/cms/pages?token=${this.token}`)
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  savePages(pages) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/cms/save`, {pages: pages, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  // *********************************************************************************************
  // * Settings                                    														    						   *
  // *********************************************************************************************
  getSettings() {
    return new Promise((resolve, reject) => {
      axios.get(`${Backend.url}/api/settings?token=${this.token}`)
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  saveSetting(data) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/settings`, {data: data, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve();
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  // *********************************************************************************************
  // * Sys                                         														    						   *
  // *********************************************************************************************


  export(mode) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/sys/export`, {mode: mode, token: this.token})
        .then((response) => {
          const data = response.data;
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  // *********************************************************************************************
  // * Scores                                     														    						   *
  // *********************************************************************************************
  postScores(city, instagram, quiz, testdrive) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/city/scores`,
        {city: city, instagram: instagram, quiz: quiz, testdrive: testdrive, token: this.token})
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  resetScores(city) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/city/scores/reset`,
        {city: city, token: this.token})
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  getMaxScore() {
    return new Promise((resolve, reject) => {
      axios.get(`${Backend.url}/api/scores/maxscore?token=${this.token}`)
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

  saveMaxScore(maxScore, maxScoreUpdate) {
    return new Promise((resolve, reject) => {
      axios.post(`${Backend.url}/api/scores/maxscore`,
        {maxScore: maxScore, maxScoreUpdate:maxScoreUpdate, token: this.token})
        .then((response) => {
          const data = response.data;
          console.log(data);
          if (data.message) return this.handleError(reject);
          resolve(data.payload);
        })
        .catch((err) => {
          this.handleError(reject);
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/Backend.js